import { CancelToken } from "axios";
import {
  ManguMangasDeliveryPromiseDependantData,
  ManguMangasDeliveryPromise,
} from "@/types";
import {DeliveryApi} from "@/api/delivery.api";

export class ManguMangasDeliveryApi extends DeliveryApi {

  calculateDelivery(
      saleId: number,
      data: ManguMangasDeliveryPromiseDependantData,
      cancelToken?: CancelToken
  ): Promise<ManguMangasDeliveryPromise> {
    return this.axios
        .post<{ promise: ManguMangasDeliveryPromise }>(
            "/delivery/mangu-mangas/promise",
            { saleId, ...data },
            { cancelToken }
        )
        .then((r) => r.data.promise);
  }
}
